 $(document).on('click', '.header-product-read-more-link', function() {
  $('.show_hidden').toggleClass('remove');
});
// $('.product-form__input input').change(function() {
//    var swatch_val = $(this).attr('data');
//    // console.log(swatch_val);
//    // console.log("hello word");
//   $(".product-slider .product-item").each(function(){
//      var mediaValue = $(this).find('.product-item-img').attr('src');  
//      // console.log(mediaValue);
//     if(swatch_val == mediaValue){
//       // console.log(mediaValue , "media value");
//       console.log(swatch_val);
//         $(this).attr("src", swatch_val);
//     }
//   });
// });

$('.product-slider').slick({
  arrows: true,
  dots: false,
  infinite: true,
  prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64da6342cb0668320f7e037d/64da6dc0a5785a57e4fad11d_p-prev.svg'>",
  nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64da6342cb0668320f7e037d/64da6dc085ab61382295e484_p-next.svg'>",
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  responsive: [{
    breakpoint: 991,
    settings: 'unslick'
  }]
});

$('.masterpiece-slider').slick({
  dots: false,
  arrows: true,
  prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64da6342cb0668320f7e037d/64da6dc0a5785a57e4fad11d_p-prev.svg'>",
  nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64da6342cb0668320f7e037d/64da6dc085ab61382295e484_p-next.svg'>",
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.related-products-slider').slick({
  dots: false,
  arrows: false,
  prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64da6342cb0668320f7e037d/64da6dc0a5785a57e4fad11d_p-prev.svg'>",
  nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64da6342cb0668320f7e037d/64da6dc085ab61382295e484_p-next.svg'>",
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

      function getTimeRemaining(endtime) {
        var t = Date.parse(endtime) - Date.parse(new Date());
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
          'total': t,
          'days': days,
          'hours': hours,
          'minutes': minutes,
          'seconds': seconds
        };
      }
      function initializeClock(id, endtime) {
        var clock = document.getElementById(id);
        if(clock == null) return;
        var daysSpan = clock.querySelector('.days');
        var hoursSpan = clock.querySelector('.hours');
        var minutesSpan = clock.querySelector('.minutes');
        var secondsSpan = clock.querySelector('.seconds');
        function updateClock() {
          var t = getTimeRemaining(endtime);
          daysSpan.innerHTML = t.days;
          hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
          minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
          secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
          if (t.total <= 0) {
            clearInterval(timeinterval);
          }
          if (t.minutes == 0 && t.seconds == 0) {
            console.log('in this func');
            deadline = new Date(deadline.getTime() + 20 * 60000);
            initializeClock('clockdiv', deadline); //added this line
          }
        }
        updateClock();
        var timeinterval = setInterval(updateClock, 1000);
      }
      var deadline = new Date(Date.parse(new Date()) + 1 * 1 * 1 * 1 * 1000);
      initializeClock('clockdiv', deadline);
